<template>
    <CompassNavigation v-if="menuFormatted.length" :menuItems="menuFormatted" :border="false" />
</template>

<script>
import generateHash from 'Helpers/hashGenerator';

export default {
    inject: ['pageLayoutSettings'],
    props: {
        customMenu: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            menu: null,
            currentMenuItem: null,
        };
    },
    computed: {
        currentUrlPath() {
            let currentUrlPath = this.$route.fullPath;
            if (currentUrlPath === '' || currentUrlPath === '/') {
                currentUrlPath = window.location.pathname;
            }
            return currentUrlPath;
        },
        menuFormatted() {
            if (!this.menu && this.menu?.length === 0) {
                return [];
            }
            if (Array.isArray(this.menu) && this.menu.at(0)?.isPlugin) {
                return this.menu.at(0).sub?.map((subItem) => {
                    let active = subItem.url ? this.currentUrlPath === subItem.url : false;
                    if (!active && subItem.route) {
                        active = this.$route.name === subItem.route.name;
                    }

                    const namePlugin = this.menu[0].label || this.menu[0].name;
                    this.currentMenuItem = {
                        label: active ? `${namePlugin} - ${subItem.label}` : namePlugin,
                    };

                    return {
                        label: subItem.label,
                        active,
                        path: subItem.url || null,
                        action: subItem.action || null,
                        route: subItem.route || null,
                        id: subItem.id || generateHash(),
                        subItems: this.getSubItems(subItem),
                    };
                });
            } else {
                return Object.values(this.menu).map((item) => {
                    return {
                        label: item.label ?? item.name,
                        id: item.id || generateHash(),
                        path: item.url || null,
                        active: item.highlight === 'Y',
                        subItems: this.getSubItems(item),
                    };
                });
            }
        },
    },
    async created() {
        this.menu = this.customMenu ? [this.customMenu] : (window.kernel.bootData.settings ?? null);

        if (!this.menu || Object.keys(this.menu).length === 0) {
            this.pageLayoutSettings.hasSidebar = false;
        }
    },
    methods: {
        getSubItems(item) {
            const subItems = item.sub ?? item.children;
            return (
                subItems?.map((subItem) => {
                    let active = subItem.url ? this.currentUrlPath === subItem.url : false;
                    if (!active && subItem.route) {
                        active = this.$route.name === subItem.route.name;
                    }

                    if (active) {
                        this.currentMenuItem = item;
                    }

                    return {
                        label: subItem.label,
                        active,
                        path: subItem.url || null,
                        action: subItem.action || null,
                        route: subItem.route || null,
                        id: subItem.id || generateHash(),
                    };
                }) ?? null
            );
        },
    },
};
</script>
